import * as React from "react";
import * as SRD from "@projectstorm/react-diagrams";
import { FiPhoneIncoming } from "react-icons/fi";
import { Container } from "./Styled";
import BasePort from "../../port/basePort/BasePort";
import { StartNodeModel } from "../../../../model/workflowEditor/nodes";

type StartWidgetProps = {
    engine: SRD.DiagramEngine;
    node: StartNodeModel;
  };
  
const StartWidget: React.FunctionComponent<StartWidgetProps> =  ({ engine, node }) => {
  return (
    <>
      <Container>
        <FiPhoneIncoming color='white' size={20}/>
      </Container>
      <BasePort
        style={{
          position: "absolute",
          bottom: "-6px",
          left: "0",
          right: "0",
          marginLeft: "auto",
          marginRight: "auto"
        }}
        engine={engine}
        port={node.getPort("in")!}
      />
    </>
  );
}

export default StartWidget;
